import { apiFetch, httpError } from '../services/apiFetch';

const API_URL = import.meta.env.VITE_API_URL;

// First-tenant provisioning. The newly-signed-up user has no active org
// yet, so this endpoint runs outside our normal tenant-scoped flow —
// TenantMiddleware bypasses its "Active organization required" gate
// for /api/Onboarding/* paths. Returns the new Clerk org id which the
// caller passes to setActive() to make it the active org.
export async function createOrg(name) {
    const res = await apiFetch(`${API_URL}/api/Onboarding/CreateOrg`, {
        method: 'POST',
        body: JSON.stringify({ name }),
    });
    if (!res.ok) throw await httpError(res, 'Failed to create organisation');
    return res.json();
}

// Returns the list of Clerk org ids the current user has an active
// User row for in MarginPal. Used by the custom <OrgSwitcher> to
// filter Clerk's userMemberships down to MarginPal-known orgs only —
// pre-existing personal Clerk orgs from other products are hidden.
export async function fetchMyOrgs() {
    const res = await apiFetch(`${API_URL}/api/Onboarding/MyOrgs`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch your organisations');
    return res.json();
}
